module.exports = __webpack_public_path__ + "img/report_img_202208.b59c6ca9.png";